import { RevealPanel } from '../classes/revealPanel';
let debounce = require('lodash.debounce');


// navHeight fix for sticky linkbar
class FixedHeightLinkBarHandler {
    items: Array<HTMLElement>;

    constructor(items: Array<HTMLElement>) {
        this.items = items;
        this.setHeightProperties();
    }

    setHeightProperties() {
        let activeHeight = 0;

        this.items.forEach(item => {
            activeHeight = Math.max(activeHeight, item.offsetHeight);
        });

        document.documentElement.style.setProperty('--linkbar-nav-clearance', `${activeHeight}px`);
    }
}


let FixedLinkBarHeaders: FixedHeightLinkBarHandler;
const fixedItems = [].slice.call(document.querySelectorAll('[data-fixed-header-linkbar]')) as Array<HTMLElement>;
if (fixedItems) {
    FixedLinkBarHeaders = new FixedHeightLinkBarHandler(fixedItems);
}

export { FixedLinkBarHeaders };

interface MenuSection {
    trigger: HTMLButtonElement;
    panel: HTMLElement;
}

export class LinkBarSubNavigation {
    container: HTMLElement;
    menuSections: Array<MenuSection>;

    constructor(linkbarNavContainer) {
        this.menuSections = [];
        this.container = linkbarNavContainer;
    }

    init() {

        const linkbarPanelEl = this.container.querySelector('[data-linkbar-panel]') as HTMLElement;
        if (linkbarPanelEl) {
            const linkbarPanel = new RevealPanel(linkbarPanelEl.id);
            linkbarPanel.on('afterOpen', () => {
                linkbarPanel.panel.style.height = "";
            });
            linkbarPanel.on('close', () => {
                linkbarPanel.panel.style.height = "";
            });

            window.addEventListener(
                'resize',
                debounce(() => {
                    linkbarPanel.panel.style.height = "";
                }, 100)
            );
        }

        const menuList = this.container.querySelector('[data-linkbar-nav-list]') as HTMLUListElement;

        if (menuList) {
            const menuListItems = [].slice.call(menuList.children);
            menuListItems.forEach(listItem => {
                const triggerChild = listItem.querySelector('[aria-haspopup]') as HTMLButtonElement;
                if (triggerChild) {
                    this.menuSections.push({
                        trigger: triggerChild,
                        panel: triggerChild.nextElementSibling as HTMLElement
                    });
                }
            });

            this.menuSections.forEach(section => {
                section.trigger.addEventListener('click', () => {
                    this.togglePanel(section);
                });
            });

            document.body.addEventListener('click', (e: Event) => {
                const clickedOutsideOfNav = !this.container.contains(e.target as Element);
                if (clickedOutsideOfNav) {
                    this.closeAllPanels();
                }
            });

            document.body.addEventListener('keyup', (e: KeyboardEvent) => {
                if (e.which == 27) {
                    this.closeAllPanels();
                }
            });
        }
    }

    togglePanel(section: MenuSection) {
        if (section.trigger && section.panel) {
            if (section.trigger.getAttribute('aria-expanded') == 'true') {
                this.closePanel(section);
            }
            else {
                this.openPanel(section);
            }
        }
    }

    openPanel(section: MenuSection) {
        this.menuSections.forEach(sectionInList => {
            if (section.trigger != sectionInList.trigger) {
                this.closePanel(sectionInList);
            }
        })
        section.trigger.setAttribute('aria-expanded', 'true');
        section.panel.setAttribute('aria-hidden', 'false');
    }

    closePanel(section: MenuSection) {
        section.trigger.setAttribute('aria-expanded', 'false');
        section.panel.setAttribute('aria-hidden', 'true');
    }

    closeAllPanels() {
        this.menuSections.forEach(sectionInList => {
            this.closePanel(sectionInList);
        });
    }

}